import {
  FUTURES_TRADING_REQUEST_DESER,
  type FuturesTradingRequest,
  type SingleResponse,
} from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"

export class FuturesTradingRequestService {
  constructor(private readonly baseHttpClient: HttpClient) {}

  readonly create = async (
    futuresTradingRequest: FuturesTradingRequest
  ): Promise<SingleResponse<FuturesTradingRequest>> =>
    this.baseHttpClient.create(
      futuresTradingRequest,
      FUTURES_TRADING_REQUEST_DESER.serialize,
      FUTURES_TRADING_REQUEST_DESER.update,
      "/futures-trading-requests"
    )
}
